import { format } from "date-fns"
import { de } from "date-fns/locale"

// The app's one date+time display format. Previously inlined identically in
// NewsPostsModal, PhotoPreviewModal, UploadReviewCard, FotoBibliothek, …
export function formatDateTime(value: string | Date): string {
  const date = typeof value === "string" ? new Date(value) : value
  return format(date, "dd.MM.yyyy HH:mm", { locale: de })
}
